<span class="tile-media">
	@if (game().image) {
		<img class="tile-image" [src]="game().image" [alt]="game().name" loading="lazy" />
	}

	@if (game().badges.length > 0) {
		<game-badge class="tile-badge" [badges]="game().badges" [phase]="game().gameId" />
	}

	<span class="tile-playing">
		<span class="tile-playing-dot" aria-hidden="true"></span>
		{{ playing() }}
	</span>
</span>

<span class="tile-name">{{ game().name }}</span>
